interface Exercise {
    id: number;
    plan_table_name: string;
    id_plan: number;
    exercise_id: number;
    exercise: {
        id: number;
        exercise: string;
        exercise_en: string;
        exercise_pt: string;
        exercise_fr: string | null;
        first_main_muscle: string;
        second_main_muscle: string | null;
        first_secondary_muscle: string | null;
        second_secondary_muscle: string | null;
        straight_bar: number;
        ez_bar: number;
        dumbbells: number;
        machines: number;
        bank: number;
        pulley: number;
        tape: number;
        elastic_band: number;
        lift_own_weight: number;
        others: number;
        first_alternative: string;
        second_alternative: string | null;
        category_default: number;
        category_runner: number;
        category_gym: number;
        category_casa: number;
        review: string;
        review_en: string;
        review_pt: string;
        review_fr: string | null;
        um: string;
        amount: string | null;
        created_at: string;
        updated_at: string;
        personalized_img: string | null;
        personalized_video: string | null;
        image_url: string;
        video_url: string;
    };
    day: string;
    category: string;
    commentary: string | null;
    commentary_custom: string | null;
    serie: string;
    repetitions: string;
    distance: string | null;
    intensity: string;
    break: string;
    target_muscle: string;
    time: string;
    speed: string | null;
    fc: string | null;
    final_rest: string | null;
    super_serie: string;
    created_at: string | null;
    updated_at: string | null;
    exercise_edit: string | null;
}

export interface DayExercises {
    day: string;
    exercises: Exercise[];
}



function groupExercisesByDay(exercises: Exercise[]): DayExercises[] {
    const days: string[] = ["1", "2", "3", "4", "5"];
    //@ts-ignore
    const groupedExercises: DayExercises[] = days.map(day => {
        // Filter exercises for the specific day
        const exercisesForDay = exercises.filter(exercise => exercise.day === day);

        // Group exercises by category
        const exercisesByCategory = exercisesForDay.reduce((acc, exercise) => {
            const category = exercise.category;
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(exercise);
            return acc;
        }, {} as Record<string, Exercise[]>);

        return {
            day,
            exercises: Object.entries(exercisesByCategory).map(([category, exercises]) => ({
                category,
                exercises
            }))
        };
    }).filter(group => group.exercises.length > 0);

    return groupedExercises;
}

export function describeExercises(groupedExercises: DayExercises[]): void {
    groupedExercises.forEach(dayExercises => {
        console.log(`Día ${dayExercises.day}:`);
        dayExercises.exercises.forEach(exercise => {
            console.log(`- ${exercise.exercise.exercise}`);
            console.log(`  Descripción: ${exercise.exercise.review}`);
            console.log(`  Video: ${exercise.exercise.video_url}`);
            console.log(`  Imagen: ${exercise.exercise.image_url}`);
            console.log(`  Comentario: ${exercise.commentary}`);
        });
    });
}

export { groupExercisesByDay };

/* const groupedExercises = groupExercisesByDay(exercises); */

